import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { useDispatch, useLogger } from '~Hooks';
import { RefreshUserToken } from './__queries__';
import * as actions from '../../actions';
import { isAuthToken } from './AuthService';

const REFRESH_USER_TOKEN = gql`
  mutation RefreshUserToken {
    refreshToken {
      success
      message
      error
      token
    }
  }
`;

// Update auth token everytime we start the app
const TokenRefresher = () => {
  const dispatch = useDispatch();
  const logger = useLogger();
  const [refreshUserToken] = useMutation<RefreshUserToken>(REFRESH_USER_TOKEN);

  useEffect(() => {
    refreshUserToken()
      .then(({ data }) => {
        const token = data?.refreshToken.token;
        const isValid = !!token && isAuthToken(token);

        if (!isValid) {
          throw new Error(`Refreshed token is invalid. Token: ${token}`);
        }

        window.postMessageReact(`authToken:${token}`);
        dispatch(actions.setToken(token));
      })
      .catch((reason) => {
        logger.warn('Could not refresh user token', { errMessage: reason });
      });
  }, []);

  return null;
};

export default TokenRefresher;
